// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1GetUserDataByRequestModel,
  IMappers,
  TCianApiSiteV1GetUserDataByRequestResponse,
  TCianApiSiteV1GetUserDataByRequestResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createCianApiSiteV1GetUserDataByRequestModel(): TCianApiSiteV1GetUserDataByRequestModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/get-user-data-by-request/',
    response: {
      '200': {
        contentType: 'json',
      },
    },
  };
}

export interface ICianApiSiteV1GetUserDataByRequestOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchCianApiSiteV1GetUserDataByRequest<TResponse200>({
  httpApi,
  config,
  mappers,
}: ICianApiSiteV1GetUserDataByRequestOptions<TResponse200>): Promise<
  FetchResponse<TCianApiSiteV1GetUserDataByRequestResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1GetUserDataByRequestModel(),
    config,
  )) as FetchResponse<TCianApiSiteV1GetUserDataByRequestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCianApiSiteV1GetUserDataByRequestResponse_1, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1GetUserDataByRequestResponse>;
}
